import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import { GreenText } from 'components'
import { OutboundTripDetailPhotosDto } from 'dtos/outboundTrips'
import { Form, Formik } from 'formik'
import { OutboundTripDetailPhotosDtoValidator } from 'validators/outboundTrips'

interface UploadReplaceDialogProps {
  initialValues: OutboundTripDetailPhotosDto
  isLoading: boolean
  onClose: () => void
  onSave: (values: OutboundTripDetailPhotosDto) => void
  open: boolean
}

export default function UploadReplaceDialog({ initialValues, isLoading, onClose, onSave, open }: UploadReplaceDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={values => onSave(values)}
        validateOnBlur={false}
        validateOnChange={true}
        validationSchema={OutboundTripDetailPhotosDtoValidator}
      >
        {({ errors, handleBlur, handleChange, setFieldValue, values }) => {
          return (
            <Form>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Outbound Trip Photos</DialogTitle>

                  <Grid item xs={12}>
                    <input
                      accept='.jpeg,.jpg,.png'
                      hidden
                      type='file'
                      id='driversLicense'
                      onChange={e => {
                        if (e.target.files && e.target.files.length > 0) setFieldValue('driversLicensePhotoFile', e.target.files[0])
                      }}
                    />

                    <Button disabled={isLoading} onClick={() => document.getElementById('driversLicense')?.click()} variant='contained'>
                      UPLOAD DRIVER'S LICENSE
                    </Button>

                    <Typography color='#808080' display='inline' variant='body2' sx={{ ml: 1 }}>
                      {values.driversLicensePhotoFile?.name ?? values.driversLicensePhotoFileName ?? 'No file uploaded'}
                    </Typography>

                    {errors.driversLicensePhotoFile && (
                      <Typography color='error' variant='body2'>
                        {errors.driversLicensePhotoFile}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <GreenText variant='outlined'>
                      {`The “Outbound Trip Photo” images allowed file types include .png, .jpg, and .jpeg with a maximum file size of 20 MB.`}
                    </GreenText>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button color='inherit' disabled={isLoading} onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton loading={isLoading} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </Form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
